import React, {useCallback, useContext, useEffect, useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {useHttp} from "../hooks/http.hook"
import config from '../config.json'
import {ViewWindowSearch} from "./ViewWindowSearch"
import {NavbarClass} from "./NavbarClass"
import {getLocalStorageItem, objectLang, set_select_by_value, setLocalStorageItem} from "../functions"

export const Navbar = ({documents = {}}) => {

    const auth = useContext(AuthContext)
    const {request} = useHttp()
    const [responseSearch, setResponseSearch] = useState(false)
    const [isChangedLang, setIsChangedLang] = useState(false)

    const fetch = useCallback(async () => {
        const lang = objectLang().language
        let l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/language/languages`,
                'GET')
            for (const i in data) {
                if (i === 'language') {
                    const lang = data[i]
                    let languages = {}
                    for (const j in lang) {
                        let language = 'en'
                        for (const k in lang) {
                            if (lang[k].lang === navigator.language.toLowerCase().split('-')[0]) {
                                language = lang[k].lang
                            }
                        }
                        if (lang[j].lang === language) {
                            if (!getLocalStorageItem('language')) {
                                setLocalStorageItem('language', lang[j])
                            }
                        }
                        languages[lang[j].lang] = lang[j]
                    }
                    setLocalStorageItem('languages', languages)
                    l = getLocalStorageItem('language').lang
                    window.location.replace(`/${l}`)
                }
            }
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [request])

    useEffect(() => {
        if (!getLocalStorageItem('languages')) {
            fetch().then()
        }
    }, [fetch])

    let currentLang = {}

    if (getLocalStorageItem('language')) {
        currentLang = getLocalStorageItem('language')
    } else {
        fetch().then(() => {
            // reloadOnceWithoutCache()
        })
    }

    const changeSelect = (event) => {
        if (!getLocalStorageItem('page')) {
            setLocalStorageItem('page', 'MainPage')
        }

        setLocalStorageItem('selectLang', event.target.value)
        const languages = objectLang().languages
        const currLang = getLocalStorageItem('selectLang')
        for (const i in languages) {
            if (i === currLang) {
                setLocalStorageItem('language', languages[i])
            }
        }
        if (auth.accessToken) {
            setLocalStorageItem('isChangedLang', 'true')
        }

        set_select_by_value('language', event.target.value)

        setIsChangedLang(true)

        let path = window.location.pathname + window.location.search
        let newPath = ''
        const arrCharPath = path.split('/')
        if (arrCharPath[1].length === 2) {
            const arr = path.split('').splice(3)
            newPath = `/${currLang}${arr.join('')}`
        } else {
            newPath = `/${currLang}${path}`
        }
        window.location.replace(newPath) // Нельзя использовать navigate()
    }

    if (responseSearch) {
        return (
            <>
                <Navbar documents={documents}/>
                <ViewWindowSearch lang={currentLang}/>
            </>
        )
    }

    if (isChangedLang) {
        return (
            <>
                <Navbar documents={documents}/>
            </>
        )
    }

    return (
        <>
            <NavbarClass
                auth={auth}
                avatarLink={auth.avatarLink}
                currentLang={currentLang}
                setResponseSearch={setResponseSearch}
                changeSelect={changeSelect}
            />
        </>
    )
}
